import { DynamicStandaloneHeading } from '@/components/Heading';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

export const AllasLabradorHeading: LabradorComponent = ({ type, data, meta }) => {
  return (
    <DynamicStandaloneHeading
      content={data.content}
      tag={data.tag}
      options={{
        // @ts-expect-error: `StandaloneHeading` component types are bugged
        className: meta.className,
      }}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default AllasLabradorHeading;
